<template>
    <!-- Layout inner -->
    <div class="layout-inner program_guide careers">
      <!-- Layout navbar -->
      <navbar></navbar>
      <!-- / Layout navbar -->
      <div class="layout-container">
        <div class="layout-content">
          <template v-if="showLoader">
            <div class="w-100 h-100 d-flex justify-content-center align-items-center">
              <spinner size="large"></spinner>
            </div>
          </template>
          <template v-if="showPage">

            <template v-if="programGuide && programGuide.title">
              <program-guide-title :program-guide="programGuide"></program-guide-title>
            </template>

            <!-- Page content -->
            <div class="container-fluid flex-grow-1 pg_content_container">
              <div class="row">
                <div class="col-12 entity_list_container">
                  <template v-if="formattedCareers.length === 0">
                    <div class="text-center mt-5">
                      <h4>No Careers available for this Program</h4>
                    </div>
                  </template>
                  <template v-for="career in formattedCareers" v-else>
                    <div class="row result_row" @click.stop="goToCareerDetail(career)">
                      <div class="col-2 thumbnail_container">
                        <div class="thumbnail thumbnail_container" v-if="career.thumbnailUrl">
													<img v-bind:src="career.thumbnailUrl"
                          alt="Img"
                          onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.svg';">
												</div>
                        <div class="thumbnail_default_name" v-if="!career.thumbnailUrl" :style="{background:setThumbnailBgColor(career.uuid)}">
                          <div class="txt_bx" v-html="setTitleInitials(career.name)"></div>
                        </div>
                      </div>
                      <div class="col-10 entity_details">
                        <div class="title">
                          <a class="title_txt" href="javascript://">{{career.name}}</a>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <!-- / Page content -->
            <program-footer-navbar :pageTitle="'Careers'" :returnTo="'programGuideMenu'" :params="{code: code, cipCode: cipCode, programGuideCode: programGuideCode, type: type, isComingFromBookmark: isComingFromBookmark}"></program-footer-navbar>
          </template>
        </div>
      </div>
    </div>
    <!-- Layout inner -->
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ProgramGuideTitle from './ProgramGuideTitle'
import Navbar from '../../misc/components/./Navbar'
import ProgramFooterNavbar from '../../misc/components/./ProgramFooterNavbar'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import VClamp from 'vue-clamp'

export default {
  name: 'programGuideRequirements',
  props: ['code', 'cipCode', 'programGuideCode', 'type', 'isComingFromBookmark'],
  components: {
    Navbar,
    ProgramGuideTitle,
    ProgramFooterNavbar,
    VClamp
  },
  data: () => {
    return {
      programGuide: {},
      showPage: false,
      showLoader: true,
      formattedProgramGuide: {},
      bookmarks: []
    }
  },

  mounted () {
    this.loadProgramGuideInfo()
  },

  methods: {
    ...mapActions([
      'loadUserObj',
      'loadProgramGuide',
      'loadInstitutionPackage',
      'loadProgramGuideCareers',
      'loadAllBookmarks',
      'loadCreateBookmarks',
      'loadDeleteBookmark'
    ]),
    async loadProgramGuideInfo () {
      await this.loadUserObj()
      await this.loadInstitutionPackage({uuid: this.userObj.institutionId, isAggregated: false})
      this.programGuide = await this.loadProgramGuide({
        cipCode: this.cipCode,
        programGuideCode: this.programGuideCode,
        type: this.type
      })
      this.formattedProgramGuide = await this.loadProgramGuideCareers({ cipCode: this.cipCode, code: this.programGuideCode })
      this.bookmarks = await this.loadAllBookmarks()
      this.showLoader = false
      this.showPage = true
    },
    addCommaInNumber (numValue) {
      return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    },
    getCareerBookmark (career) {
      let bookmarks = this.bookmarks
      if (!bookmarks || !bookmarks.length) {
        return false
      }
      let target = false
      bookmarks.forEach(bookmark => {
        if (bookmark.entityUuid === career.uuid) {
          target = bookmark
        }
      })
      return target
    },
    isBookmarked (career) {
      return career.bookmark && career.bookmark.uuid
    },
    async bookmarkCareer (career) {
      const bookmark = {
        'source': 'explore',
        'entityType': 'career',
        'entityTitle': career.name,
        'entityUuid': career.uuid,
        // 'institutionId': career.institutionId,
        'userId': this.userId
      }
      const response = await this.loadCreateBookmarks(bookmark)
      const message = (response ? 'Successfully bookmarked \'' : 'Unable to bookmark \'') + career.name + '\''
      const notify = response ? this.notifySuccess : this.notifyFailure
      notify(message)
      await this.loadAllBookmarks() // Refresh Vuex state to mark Career as bookmarked
    },
    async deleteCareerBookmark (career) {
      await this.loadDeleteBookmark(career.bookmark.uuid)
      await this.loadAllBookmarks() // Refresh Vuex state to mark Career as bookmarked
    },
    setTitleInitials (title) {
      let getTitleInitials = title.match(/\b(\w)/g)
      return getTitleInitials.join('')
    },
    setThumbnailBgColor (entityId) {
      let getNumricValue = entityId.replace(/[^0-9]/g, '')
      return '#' + getNumricValue.slice((getNumricValue.length - 8), (getNumricValue.length - 2))
    },
    goToCareerDetail (career) {
      let routerParams = {
        code: career.code,
        cipCode: this.cipCode,
        programGuideCode: this.programGuideCode,
        type: this.type,
        isComingFromBookmark: this.isComingFromBookmark
      }
      if (this.isComingFromBookmark) {
        return this.$router.push({name: 'careerHome', params: routerParams, query: this.$route.query})
      }
      return this.$router.push({name: 'careerHome', params: routerParams, query: {returnTo: 'programGuideCareers', pageTitle: 'Careers'}})
    },
    hideUserNamePopup () {
      this.$refs.userNamePopupContainer.$emit('close')
    }
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj,
      'enabledFeatures': state => state.dashboard.enabledFeatures,
      'packages': state => state.dashboard.packages
    }),
    userName () {
      if (this.userObj) {
        return this.userObj.firstName + ' ' + this.userObj.lastName
      } else {
        return ''
      }
    },
    exploreProgramDetailFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },

    showMedianIncome () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryMedianIncome) {
        return false
      }
      return exploreProgramDetailFlagMap.programDetailSummaryMedianIncome.enabled
    },
    medianIncomeLabel () {
      const defaultLabel = 'median income'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryMedianIncome) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.programDetailSummaryMedianIncome.label || defaultLabel
    },

    showJobPostings () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryJobPostings) {
        return false
      }
      return exploreProgramDetailFlagMap.programDetailSummaryJobPostings.enabled
    },
    jobPostingsLabel () {
      const defaultLabel = 'job postings'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryJobPostings) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.programDetailSummaryJobPostings.label || defaultLabel
    },

    showGrowthRate () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryGrowthRate) {
        return false
      }
      return exploreProgramDetailFlagMap.programDetailSummaryGrowthRate.enabled
    },
    growthRateLabel () {
      const defaultLabel = 'growth rate'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.programDetailSummaryGrowthRate) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.programDetailSummaryGrowthRate.label || defaultLabel
    },

    currencyLabel () {
      return '$'
    },

    formattedCareers () {
      let careers = this.formattedProgramGuide
      let formattedCareers = []
      if (!careers || !careers.targetOccupations || !careers.targetOccupations.length || !careers.targetOccupations.length === 0) {
        return formattedCareers
      }
      let getBookmark = this.getCareerBookmark
      careers.targetOccupations.forEach((careerObj) => {
        let career = JSON.parse(careerObj)
        career.bookmark = getBookmark(career)
        formattedCareers.push(career)
      })
      return formattedCareers
    }
  },

  watch: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideCareers.vue